import { Input } from "../../../../../components/Input/input";
import styled from "styled-components";
import * as yup from "yup";
import { useFormik } from "formik";
import { FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { ToastOptions, toast } from "react-toastify";
import { StyledButton } from "../../../../../components/Button/button";
import { theme } from "../../../../../helpers/theme";
import { putServicesUpdate } from "../../../../../services/warehouses/services-update";


interface ServicesEditFormProps {
  id: string;
  usluga: string;
  typ_uslugi: string;
  aktywny: boolean | string;
  wymaga_wyceny: boolean | string;
  info_dodatkowe: string;
  handleClose: () => void;
}

export const ServicesEditForm = ({
  id,
  usluga,
  typ_uslugi,
  aktywny,
  wymaga_wyceny,
  info_dodatkowe,
  handleClose,
}:ServicesEditFormProps) => {
  


  const reverseGetServiceFromEnum = (purpose: string) => {
    switch (purpose) {
      case "Składowanie":
        return 0;
      case "Cross-docking":
        return 1;
      case "Fullfilment":
        return 2;
      case "Etykietowanie":
        return 3;
      case "Pakowanie":
        return 4;
      case "Sortowanie":
        return 5;
      case "E-commerce":
        return 6;
      case "Wysyłka":
        return 7;
      case "Inne":
        return 8;
      case "Przyjęcie Towaru":
        return 9;
      case "Wydanie Towaru":
        return 10;
    }
  };

  const reverseGetTypeFromEnum = (type: string) => {
    switch (type) {
      case "Główna":
        return 0;
      case "Dodana":
        return 1;
      case "Dodatkowa":
        return 2;
    }
  };
  const settings: ToastOptions<{}> = {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    theme: "light",
  };


  const EditServicesMutation = useMutation(putServicesUpdate, {
    onSuccess: (res) => {
      toast.success("Edytowano pomyślnie!", { toastId: "EditSuccessfully", ...settings });
      handleClose();
    },
  });

  const validationSchema = yup.object({
    aktywny: yup
      .string(),
    wymaga_wyceny: yup
      .string(),
    info_dodatkowe: yup
      .string()
      .max(100, "Maksymalnie 100 znaków"),
  });
  const formik = useFormik({
    initialValues: {
      id,
      usluga,
      typ_uslugi,
      aktywny,
      wymaga_wyceny,
      info_dodatkowe,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const body = {
        id: values.id,
        usluga: reverseGetServiceFromEnum(values.usluga),
        typ_uslugi: reverseGetTypeFromEnum(values.typ_uslugi),
        czy_aktywna: values.aktywny === "Tak" ? true : false,
        czy_wymaga_wyceny: values.wymaga_wyceny === "Tak" ? true : false,
        info_dodatkowe: values.info_dodatkowe,
      };
      EditServicesMutation.mutate(body);
    },
  });

  return (
      <ServicesEditFormWrapper onSubmit={formik.handleSubmit}>
        <FormWrapper>
        <FormLabel id="active-label">Aktywny</FormLabel>
          <RadioGroup
            aria-labelledby="active-label"
            defaultValue={formik.values.aktywny}
            name="aktywny"
            value={formik.values.aktywny}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          >
            <FormControlLabel value="Tak" control={<Radio />} label="Aktywny" />
            <FormControlLabel value="Nie" control={<Radio />} label="Niekatywny" />
          </RadioGroup>

          <FormLabel id="pricing-label">Wymaga wyceny</FormLabel>
          <RadioGroup
            aria-labelledby="pricing-label"
            defaultValue={wymaga_wyceny}
            name="wymaga_wyceny"
            value={formik.values.wymaga_wyceny}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          >
            <FormControlLabel value="Tak" control={<Radio />} label="Tak" />
            <FormControlLabel value="Nie" control={<Radio />} label="Nie" />
          </RadioGroup>

          <Input
            label="Info dodatkowe"
            id="info_dodatkowe"
            name="info_dodatkowe"
            value={formik.values.info_dodatkowe}
            onChange={formik.handleChange}
            error={formik.touched.info_dodatkowe && Boolean(formik.errors.info_dodatkowe)}
            helperText={formik.touched.info_dodatkowe && formik.errors.info_dodatkowe}
            onBlur={formik.handleBlur}
            variant="filled"
            style={{ marginTop: 11 }}
          />

          <StyledButton disabled={!formik.isValid || EditServicesMutation.isLoading} type="submit" variant="contained">
            Zapisz
          </StyledButton>
        </FormWrapper>
      </ServicesEditFormWrapper>
  );
};

export default ServicesEditForm;

const ServicesEditFormWrapper = styled.form`
  width: 100%;
  margin-bottom: 40px;
  display: flex;
  justify-content: center;
  // padding: 0 40px;

  @media (${theme.device.laptop}){
    width: 100%;
    // padding: 0 10px;
  }
`;

const FormWrapper = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width:260px;
  max-width:420px;
  gap: 25px;

  @media (${theme.device.laptop}){
    width: 100%;
  }
`;


